import React from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

function MultiSearchSelect({options, selected, setSelected, style, simple = true, maxMenuHeight, placeholder, disabled = false}) {
  return (
    <Select
      placeholder={placeholder}
      closeMenuOnSelect={false}
      components={animatedComponents}
      value={simple ? selected.map(s => ({label: s, value: s})) : selected}
      isMulti
      options={simple ? options.map(s => ({label: s, value: s})) : options}
      onChange={(list) => simple ? setSelected(list.map(s => s.label)) : setSelected(list)}
      maxMenuHeight={maxMenuHeight}
      isDisabled={disabled}
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          width: '400px',
          maxWidth: '100%',
          ...style
        }),
      }}
    />
  );
}

export default MultiSearchSelect;